import { extend } from 'vee-validate';
import {
  required,
  min_value as minValue,
  max_value as maxValue,
  numeric,
  email,
  ext,
} from 'vee-validate/dist/rules';

import attachment from './validateRules/attachment';
import attachments from './validateRules/attachments';
import notLaterToday from './validateRules/notLaterToday';

extend('required', required);
extend('min_value', minValue);
extend('max_value', maxValue);
extend('numeric', numeric);
extend('email', email);
extend('ext', ext);
extend('size', attachment);
extend('sumSize', attachments);
extend('notLaterToday', notLaterToday);
